module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.model.hidden) ? _c('div', [(_vm.nonChildren) ? [(!_vm.model.url) ? _c('el-menu-item', {
    key: _vm.path,
    attrs: {
      "index": _vm.path
    }
  }, [(_vm.model.iconCls) ? _c('i', {
    staticClass: "iconfontmod",
    domProps: {
      "innerHTML": _vm._s(_vm.model.iconCls)
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.model.name) + "\n\t\t  ")]) : _vm._e(), _vm._v(" "), (_vm.model.url) ? _c('li', {
    staticClass: "el-menu-item",
    on: {
      "click": function($event) {
        _vm.goTo(_vm.model.url)
      }
    }
  }, [(_vm.model.iconCls) ? _c('i', {
    staticClass: "iconfontmod",
    domProps: {
      "innerHTML": _vm._s(_vm.model.iconCls)
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.model.name) + "\n\t\t  ")]) : _vm._e()] : [_c('el-submenu', {
    attrs: {
      "index": _vm.path
    }
  }, [
    [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(_vm.model.iconCls) ? _c('i', {
      staticClass: "iconfontmod",
      domProps: {
        "innerHTML": _vm._s(_vm.model.iconCls)
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.model.name))])], _vm._v(" "), _vm._l((_vm.model.children), function(child, index) {
      return (_vm.model.children) ? _c('items', {
        key: index,
        attrs: {
          "model": child,
          "parentItem": _vm.model,
          "parentPath": _vm.parentPath
        }
      }) : _vm._e()
    })
  ], 2)]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e49088f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/conf/index/items.vue
// module id = 274
// module chunks = 123